<script lang="ts" setup>
import { useValidation } from "@/composables/useValidation";
import { computed } from "vue";

const model = defineModel<string>();
const props = withDefaults(
  defineProps<{
    label: string;
    required?: boolean;
  }>(),
  {
    required: false,
  },
);

const { requiredValidator, phoneValidator } = useValidation();

const rules = computed(() => {
  const result = [phoneValidator];

  if (props.required) {
    result.push(requiredValidator);
  }

  return result;
});
</script>

<template>
  <v-text-field
    v-model="model"
    v-phone
    :class="{
      required: props.required,
    }"
    :label="props.label"
    :rules="rules"
    autocomplete="off1"
    color="primary"
    density="compact"
    hide-details="auto"
    variant="outlined"
  />
</template>
